import React from 'react';
import ReactDOM from 'react-dom';

import MultiAttendanceList from '../apps/onsite_attendance/components/MultiAttendanceList';
import Events from '../apps/onsite_attendance/models/Events';

const event_guids = (window._events || []).filter(e => e);
const csrf = window._csrf || '';

const events = new Events({ guid: event_guids, csrf });

ReactDOM.render(
    <MultiAttendanceList events={events} />,
    document.getElementById('attendance-list')
);
